import React from 'react';
import './ChatSkeleton.css';

const ChatSkeleton: React.FC = () => {
  return (
    <div className="chat-skeleton-container">
      {/* Chat Header */}
      <div className="chat-header-skeleton">
        <div className="skeleton-chat-title"></div>
        <div className="skeleton-online-count"></div>
      </div>

      {/* Messages Area */}
      <div className="chat-messages-skeleton">
        {[...Array(8)].map((_, index) => (
          <div key={index} className="chat-message-skeleton">
            <div className="skeleton-avatar"></div>
            <div className="skeleton-message-content">
              <div className="skeleton-username"></div>
              <div className="skeleton-message-text" style={{ width: `${60 + Math.random() * 30}%` }}></div>
            </div>
          </div>
        ))}
      </div>

      {/* Input Area */}
      <div className="chat-input-skeleton">
        <div className="skeleton-input-field"></div>
        <div className="skeleton-send-button"></div>
      </div>
    </div>
  );
};

export default ChatSkeleton;
